import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

const elements = document.querySelectorAll( '[data-events-archive-load]' )

Object.keys( elements ).map( ( key, i ) => {
  let e      = elements[ key ]
  let id     = e.getAttribute( 'id' )
  let params = JSON.parse( atob( e.getAttribute( 'data-params' ) ) )
  return (
    ReactDOM.render(
      <React.StrictMode>
        <App params={ params } />
      </React.StrictMode>,
      document.getElementById( id )
    )
  )
})
